import {UnknownStructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';

/** Returns the index of the Condition-Replicate column on the given table, or undefined if the table does
 * not currently have one. */
export function findProcedureConditionReplicateColumnIndex(
  structuredTable: UnknownStructuredTable
): number | undefined {
  const index = structuredTable.columns.findIndex(
    (column) => column.columnType === TableColumnType.PROCEDURE_CONDITION_REPLICATES
  );
  return index === -1 ? undefined : index;
}
